import { connect } from 'react-redux'
import {
  resendEmailVerification,
} from 'reduxpath/ducks/User/List'

import SendButtonActive from './units'

const mapDispatchToProps = dispatch => ({
  resendEmail(email) {
    return () => {
      dispatch(resendEmailVerification({
        email,
      }))
    }
  },
})

export default connect(null, mapDispatchToProps)(SendButtonActive)
